import CfCLogo from '@/assets/branding/codeforchange/CodeForChangeLogo.png';

export default {
  name: 'Code for Change',
  isSAML: true,
  allowPersonalCourses: false,
  logo: CfCLogo,
  colors: {
    // Brand colors
    brand_primary: '#137DC5',
    brand_primary_hover: '#155E8D', // −10 L, −8 S
    brand_primary_highlight: '#56B6F5', // +23 L, +7 S
    brand_primary_mid: '#1495EB', // +8 L,  +2 S
    brand_primary_dark: '#09324E', // −25 L, −3 S (clamped)
    brand_secondary: '#154974', // hue +4°, −15 L, −13 S
  },
};
